module.exports = __webpack_public_path__ + "img/Flag_of_Singapore.924d3574.svg";